import { ELandLineListActions, LandLineListActions } from '../actions/land-line-list.actions';
import { initialLandLineListState, LandLineListInterfaceState } from '../state/land-line-list.state';

export function landLineListReducer( state: LandLineListInterfaceState = initialLandLineListState, action: LandLineListActions): LandLineListInterfaceState {
  switch (action.type) {
    case ELandLineListActions.GetLandLineListSuccess: {
      return { ...state, list: action.payload };
    }

    default:
      return state;
  }
}
